export default "__VITE_ASSET__psrP$XWc__"